import { AddOnDefinition, AddOns } from '..';

const definition: AddOnDefinition = {
	addOn: AddOns.CLOUD_POS,
	blockSlots: 1,
	manualSetup: true,
};

export default definition;
